import { ChartData, ChartOptions } from 'chart.js';
import { useEffect, useMemo, useState, useLayoutEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Chart } from 'primereact/chart';

export interface GraphLinearProps {
  data: ChartData;
  options: ChartOptions;
}

export function GraphLinear(props: Readonly<GraphLinearProps>) {
  const { i18n } = useTranslation();
  const [chartData, setChartData] = useState<ChartData>(props.data);
  const [resizeKey, setResizeKey] = useState(0);

  // Aumentamos el tamaño del punto si solo hay un dato
  const enhancedData = useMemo(() => {
    if (!props.data || !Array.isArray(props.data.datasets)) return props.data;
    const labelsLength = Array.isArray(props.data.labels)
      ? props.data.labels.length
      : 0;
    // Si solo hay un label, aumentar el tamaño del punto en todos los datasets
    if (labelsLength === 1) {
      return {
        ...props.data,
        datasets: props.data.datasets.map((ds) => ({
          ...ds,
          pointRadius: 8,
          pointHoverRadius: 12,
        })),
      };
    }
    return props.data;
  }, [props.data]);

  // SOLO lo imprescindible: responsive + sin aspect ratio
  const chartOptions = useMemo<ChartOptions>(
    () => ({
      ...props.options,
      responsive: true,
      maintainAspectRatio: false,
    }),
    [props.options]
  );

  useEffect(() => {
    setChartData(enhancedData);
  }, [i18n.language, enhancedData, props.options]);

  useLayoutEffect(() => {
    const handleResize = () => setResizeKey((prev) => prev + 1);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    // El CONTENEDOR PADRE debe dar la altura (PrimeFlex)
    <div className="py-2" style={{ width: '100%', height: '100%' }}>
      <Chart
        key={resizeKey}
        type="line"
        data={chartData}
        options={chartOptions}
        style={{ width: '100%', height: '100%' }} // <- clave
      />
    </div>
  );
}

export default GraphLinear;
